import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { Form } from '@backstage/plugin-scaffolder-react/alpha';

import {
  createScaffolderFieldExtension,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import { GlobalSelect } from './GlobalSelect';
import { useMemo } from 'react';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core';
import type { ValidatorType } from '@rjsf/utils';

export interface FormWithGlobalSelectOptions {
  items: Record<string, string>;
  label: string;
  properties: Record<string, any>;
}
const useStylers = makeStyles(t => ({
  divider: {
    marginTop: t.spacing(6),
    marginBottom: t.spacing(1),
    position: 'relative',
    left: -t.spacing(2),
    width: `calc(100% + ${t.spacing(4)}px)`,
  },
}));
const noopValidator: ValidatorType = {
  isValid: () => true,
  rawValidation: () => ({}),
  validateFormData: () => ({ errors: [], errorSchema: {} }),
  reset: () => {},
  toErrorList: () => [],
};
export function PageWithGlobalSelect(
  props: FieldExtensionComponentProps<FormWithGlobalSelectOptions>,
) {
  const { formContext, formData, uiSchema, onChange } = props;
  const { divider } = useStylers();
  const options: FormWithGlobalSelectOptions = (uiSchema['ui:options'] ??
    {}) as any;
  const fields = useMemo(
    () => Object.keys(options.properties ?? {}),
    [options.properties],
  );
  return (
    <div>
      <GlobalSelect
        label={options.label}
        values={options.items}
        fields={fields}
        formData={formData}
        onChange={newForm => onChange(newForm)}
      />

      <Divider className={divider} />
      <Form
        schema={uiSchema['ui:options'] ?? {}}
        formContext={formContext}
        formData={formData}
        onChange={(data, id) => onChange(data.formData, undefined, id)}
        noValidate
        validator={noopValidator}
      >
        <div />
      </Form>
    </div>
  );
}

export const PageWithGlobalSelectFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'FGlobalSelect',
    component: PageWithGlobalSelect,
  }),
);
